import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SituationRecordDTO, TimetableService } from 'ticket-sdk';

@Injectable({
  providedIn: 'root'
})
export class SituationService {

  private situations$: BehaviorSubject<SituationRecordDTO[]> = new BehaviorSubject(null);

  constructor(
    private timeTableService: TimetableService,
    ) { }

  getSituations(): Observable<SituationRecordDTO[]> {
    return this.situations$.asObservable();
  }

  updateSituations() {
    this.timeTableService.getSituations()
    .pipe(take(1))
    .subscribe(situations => this.situations$.next(situations.listOfEntityObjects));
  }
}
